/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Button, Divider, Grid, Typography } from "@mui/material";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import { IconArrowBack } from "@tabler/icons";
import GeofencingService from "src/service/geofencing";
import PolygonGeofenceMap from "src/components/mapFencing/PolygonGeofenceMap";
import { Autocomplete } from "@react-google-maps/api";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "GeoFencing Setup",
  },
];

const validationSchema = yup.object({
  geo_fence_name: yup
    .string("Enter Geofence name")
    .required("Geofence name is Required"),
});

const Addgeofencing = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const [starting_place_name, setStarting_place_name] = useState("");
  const [starting_latitude, setStarting_latitude] = useState("");
  const [starting_longitude, setStarting_longitude] = useState("");

  const [geofenceData, setGeofenceData] = useState([]);

  const [startMarker, setStartMarker] = useState({
    position: { lat: 23.876536, lng: 85.876453 },
    address: "",
  });

  // eslint-disable-next-line no-unused-vars
  const [endMarker, setEndMarker] = useState({
    position: { lat: 23.876536, lng: 85.876453 },
    address: "",
  });

  const getGeofenceData = (data) => {
    setGeofenceData(data);
    // console.log("data---", data);
    // console.log("string---", JSON.stringify(data));
  };
  const onAutocompleteLoadStart = (autocomplete) => {
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        setStartMarker({
          position: { lat, lng },
          address: place.formatted_address,
        });

        setStarting_place_name(place.formatted_address);
        setStarting_latitude(lat);
        setStarting_longitude(lng);
      }
    });
  };

  // Function to reverse geocode latitude and longitude to get the place name

  const calculateEndingCoordinates = (startLat, startLng, distance) => {
    const endingLat = startLat + distance / 111.32;
    const endingLng = startLng;
    return { lat: endingLat, lng: endingLng };
  };

  const initialValues = {
    geo_fence_name: "",
    coordinates: "",
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        const payloadval = {
          geo_fence_name: values.geo_fence_name,
          coordinates: JSON.stringify(geofenceData),
          c_by: sessionData.data.id,
        };
        try {
          const res = await GeofencingService.addgeofencingdata(payloadval);
          swal("Success", res.message, "success");
          setTimeout(() => {
            navigate("/geofencing");
          }, 1000);
        } catch (error) {
          swal("Error", error, "error");
        }
      },
    });

  const handleValuesChange = () => {
    if (starting_latitude && starting_longitude && values.radius) {
      const endingCoordinates = calculateEndingCoordinates(
        parseFloat(starting_latitude),
        parseFloat(starting_longitude),
        parseFloat(values.radius)
      );
      setEndMarker({
        position: endingCoordinates,
        address: `Geofencing Area (Radius: ${values.radius} km)`,
      });
    }
  };

  useEffect(() => {
    handleValuesChange();
  }, [starting_latitude, starting_longitude, values.radius]);

  // Update place name when latitude or longitude changes

  useEffect(() => {
    if (starting_latitude && starting_longitude) {
      setStartMarker({
        position: {
          lat: parseFloat(starting_latitude),
          lng: parseFloat(starting_longitude),
        },
        address: starting_place_name,
      });
    }
  }, [starting_latitude, starting_longitude, starting_place_name]);

  return (
    <>
      <Breadcrumb title="Geo Fencing" items={BCrumb} />
      <ParentCard title="" style={{ minHeight: "600px !important" }}>
        <Grid container alignItems="center">
          <Grid item xs={4}>
            <Typography
              variant="h2"
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
                marginTop: "15px",
                marginBottom: "15px",
              }}
            >
              Add GeoFencing
            </Typography>
          </Grid>
          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginTop: "15px",
              marginBottom: "15px",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/geofencing")}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container spacing={3}>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <CustomFormLabel htmlFor="geo_fence_name">
                    Geo fence Name <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id="geo_fence_name"
                    name="geo_fence_name"
                    type="text"
                    value={values.geo_fence_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.geo_fence_name && Boolean(errors.geo_fence_name)
                    }
                    helperText={touched.geo_fence_name && errors.geo_fence_name}
                    placeholder="Enter geo fence name"
                    fullWidth
                  />
                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <CustomFormLabel htmlFor="place_name">
                    Place Name
                  </CustomFormLabel>
                  <Autocomplete onLoad={onAutocompleteLoadStart}>
                    <CustomTextField
                      type="text"
                      value={starting_place_name}
                      onChange={(e) => {
                        setStarting_place_name(e.target.value);
                      }}
                      onBlur={handleBlur}
                      placeholder="Enter starting address"
                      fullWidth
                    />
                  </Autocomplete>
                </Grid>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <PolygonGeofenceMap
                  center={startMarker.position}
                  radius={values.radius}
                  markerPosition={startMarker.position}
                  geofenceData={getGeofenceData}
                />
              </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12}>
              <Button type="submit" color="success" variant="contained">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </>
  );
};

export default Addgeofencing;
